import { css } from '@emotion/css';
import { CSSProperties } from 'react';

export const blockTitle: CSSProperties = {
  fontWeight: 300,
  fontSize: '23px',
  lineHeight: '27px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
  alignItems: 'center',
  letterSpacing: '0.03em',
  padding: '1.5em',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
};

export const blockSubTitle: CSSProperties = {
  fontWeight: 230,
  fontSize: '20px',
  lineHeight: '27px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
  alignItems: 'center',
  letterSpacing: '0.03em',
  padding: '1em',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
};

export const optionStyle: CSSProperties = {
  padding: 5,
  fontWeight: 230,
  fontSize: 18,
  lineHeight: '18px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#000000',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: 0.03,
  marginBottom: 10,
};

export const dotStyle: CSSProperties = {
  display: 'inline-block',
  width: 6,
  height: 6,
  borderRadius: 50,
  backgroundColor: '#ee8864',
  marginRight: 8,
};

export const summaryListTitle: CSSProperties = {
  padding: 5,
  fontWeight: 500,
  fontSize: 20,
  lineHeight: '27px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: 0.03,
};

export const summaryListItem: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  backgroundImage: 'linear-gradient(to right, #000 10%, rgba(255, 255, 255, 0) 0%)',
  backgroundPosition: '0 32px',
  backgroundSize: '10px 1px',
  backgroundRepeat: 'repeat-x',
  height: '60px',
  position: 'relative',
};

export const summaryListItemTitle: CSSProperties = {
  background: '#fff',
  paddingLeft: 10,
  paddingRight: 10,
  padding: 5,
  fontWeight: 230,
  fontSize: 16,
  minHeight: 52,
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: 0.03,
  maxWidth: '60%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  position: 'relative',
  zIndex: 2,
};

export const summaryListItemPrice: CSSProperties = {
  paddingLeft: 10,
  paddingRight: 10,
  padding: 5,
  fontWeight: 230,
  fontSize: 16,
  minHeight: 52,
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: 0.03,
  position: 'relative',
  zIndex: 2,
  marginLeft: 'auto',
};

export const summaryImg: CSSProperties = {
  width: '100%',
  aspectRatio: 1 / 1,
  objectFit: 'contain',
  backgroundColor: 'rgb(239, 239, 239)',
};

export const fixedHeaderStyle = css`
  background-color: white;
  padding: 10px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: 100%;
  z-index: 10;
  transform: translateY(-100%);
  animation: slideDownIn 0.3s ease-out forwards;

  &.slide-out {
    animation: slideDownOut 0.3s ease-in forwards;
  }

  @keyframes slideDownIn {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes slideDownOut {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-100%);
    }
  }
`;

export const titleStyle = css`
  font-weight: 230;
  font-size: 14px;
  line-height: 18px;
  color: #4a4a4a;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const priceStyle = css`
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #000000;
  margin: 0;
`;

export const iconButtonStyle = css`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`;

export const cartButtonStyle = css`
  ${iconButtonStyle}
  background-color: #EE8865;
  color: #000000;
  border: none;
  margin-right: 8px;

  &:hover,
  &:focus {
    background-color: #f2a183;
    color: #000000;
  }
`;

export const phoneButtonStyle = css`
  ${iconButtonStyle}
  background-color: white;
  color: #000000;
  border: 1px solid #ee8865;

  &:hover,
  &:focus {
    border-color: #f2a183;
    color: #000000;
  }
`;

export const buttonLabelStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 300,
  color: '#454545',
  marginBottom: '8px',
  marginTop: '8px',
  textAlign: 'left',
  fontFamily: 'Open Sans, sans-serif',
};

export const mobileFixedButtonStyle = css`
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0 16px 8px 16px;
  background-color: #ffffff;
  border-top: 1px solid #e8e8e8;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(100%);
  animation: slideUpIn 0.3s ease-out forwards;

  &.no-user {
    bottom: 0;
  }

  &.slide-out {
    animation: slideUpOut 0.3s ease-in forwards;
  }

  @keyframes slideUpIn {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes slideUpOut {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(100%);
    }
  }
`;
